"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultEffects = void 0;
var FluentDepths_1 = require("./FluentDepths");
exports.DefaultEffects = {
    elevation4: FluentDepths_1.Depths.depth4,
    elevation8: FluentDepths_1.Depths.depth8,
    elevation16: FluentDepths_1.Depths.depth16,
    elevation64: FluentDepths_1.Depths.depth64,
    roundedCorner2: '2px',
    roundedCorner4: '4px',
    roundedCorner6: '6px',
};
//# sourceMappingURL=DefaultEffects.js.map